module.exports = __webpack_public_path__ + "media/images/gfx/selected-5847982ac62529a013e1d486984bf4a8.gif";